import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "delete"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "This action is irreversible and all the server data will be lost", -1)
const _hoisted_3 = { class: "cta-section flex flex-row gap-3 justify-content-end" }
const _hoisted_4 = {
  key: 1,
  class: "delete-pending"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Deleting...", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 2,
  class: "delete-complete"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "Guild Deleted", -1)
const _hoisted_9 = { class: "flex justify-content-end" }

import { watch } from 'vue';
import { useGuildStore } from '@/stores/GuildStore';
import { useApiStatusStore } from '@/stores/ApiStatusStore';
import { useDialogStore } from '@/stores/DialogStore';
import router from '@/router';
import Button from 'primevue/button';


export default /*#__PURE__*/_defineComponent({
  __name: 'GuildDelete',
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const guildStore = useGuildStore();
const apiStatusStore = useApiStatusStore();
const emit = __emit;

function closeOnDeleted(){
  emit('close');
  router.replace({name: 'base'});
}

watch(() => apiStatusStore.requestFulfilled('delete_guild'), (newValue) => {
  if (newValue) {
    useDialogStore().changeHeader('Guild succesfully deleted')
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(apiStatusStore).requests.get('delete_guild'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(Button), {
              label: "Cancel",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
            }),
            _createVNode(_unref(Button), {
              label: "Delete",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(guildStore).deleteGuild())),
              disabled: _unref(apiStatusStore).requestPending('delete_guild')
            }, null, 8, ["disabled"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(apiStatusStore).requestPending('delete_guild'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
      : _createCommentVNode("", true),
    (_unref(apiStatusStore).requestFulfilled('delete_guild'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_unref(Button), {
              label: "Close",
              onClick: closeOnDeleted
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})